<template>
  <l-columns>
    <a-loading :loading="jurisdictionMeta.loading">
      <l-columns-column size="7">
        <l-rows>
          <o-form
            :inputs="inputs"
            :initial-values="jurisdiction"
            :title="$t('masterData.editJurisdiction')"
            :submit-text="$t('common.save')"
            @submit="editJurisdiction"
          />
          <a-box>
            <o-form
              :title="$t('masterData.deleteJurisdiction')"
              :subtitle="$t('masterData.deleteJurisdictionDescription')"
              submit-variant="danger"
              :submit-text="$t('common.delete')"
              @submit="deleteJurisdiction"
            />
          </a-box>
        </l-rows>
      </l-columns-column>
    </a-loading>
  </l-columns>
</template>

<script>
  import { ABox, ALoading, LColumns, LColumnsColumn, LRows, OForm, } from 'codefabrik-gui-vue'
  import {
    useJurisdiction, useDeleteJurisdiction,
    useEditJurisdiction
  } from '@/views/casinos/casinoHooks'

  export default {
    name: 'Jurisdiction',
    components: { LRows, LColumns, LColumnsColumn, OForm, ALoading, ABox },
    computed: {
      inputs () {
        return [
          {
            name: 'key',
            validators: 'required',
            properties: {
              label: this.$t('common.key')
            }
          },
          {
            name: 'description',
            validators: 'required',
            properties: {
              label: this.$t('common.description')
            }
          }
        ]
      },
    },
    mixins: [
      useJurisdiction(),
      useEditJurisdiction(),
      useDeleteJurisdiction(),
    ]
  }
</script>

<style scoped>

</style>
